import { useEffect } from "react";
import { useSelector } from "react-redux";
import { queryModalTypeName } from "@nxplatform/helpers/constants/common";
import { useQuery } from "./query.hook.js";
import { selectDisabledShowModals } from "@nxplatform/platform-settings/platform-settings.selectors";
const useQueryModalOpenerHook = ({
  openModal
}) => {
  const modalTypeFromQuery = useQuery().get(queryModalTypeName);
  const disabledModals = useSelector(selectDisabledShowModals);
  useEffect(() => {
    if (modalTypeFromQuery) {
      if (!disabledModals.includes(modalTypeFromQuery)) {
        openModal(modalTypeFromQuery);
      } else {
        window.history.replaceState({}, "", window.location.pathname);
      }
    }
  }, [modalTypeFromQuery]);
};
export {
  useQueryModalOpenerHook
};
